var _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleProgress = function SvgCircleProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15,
    "stroke-mitterlimit": 0,
    cx: 50,
    cy: 50,
    r: 38,
    strokeDasharray: 360,
    strokeLinecap: "round",
    transform: "rotate(-90 ) translate(-100 0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "360;-360",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
};

export { SvgCircleProgress as ReactComponent };
export default __webpack_public_path__ + "static/media/images/circleProgress.svg";